import {
  Button,
  Dialog,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Row } from "@tanstack/react-table";

type ControlFinding = {
  control_ref: string;
  status: string;
};

type TagData = {
  Key: String;
  Value: String;
}

type PropertiesProp = {
  Data: TagData[];
  LastReportedAt: string;
  Name: string;
}

interface ResourceRow {
  Arn: string;
  Identifier: string;
  Service: string;
  ResourceType: string;
  Region: string;
  OwningAccountId: string;
  ControlFindings: ControlFinding[];
  Properties: PropertiesProp;
}

const MultiResourceDialogSelect = ({
  open,
  rows,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  rows: Row<ResourceRow>[];
  handleClose: any;
  handleConfirm: any;
}) => {

  const resources = rows
  .map((row) => ({
    Arn: row.original.Arn,
    ResourceType: row.original.ResourceType,
    Region: row.original.Region,
    OwningAccountId: row.original.OwningAccountId,
  }));

  const handleSubmit = async () => {
    handleConfirm(resources);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="alert-dialog-title">
          Create Resource Group & Tag Resources
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{ m: 1 }} fontSize={"14px"}>
            You are about to create a resource group & tag resources for the following.
          </Grid>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Resource ARN</TableCell>
                  <TableCell>Resource Type</TableCell>
                  <TableCell>Owner Account ID</TableCell>
                  <TableCell>Region</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resources.map((resource, index) => (
                  <TableRow key={index}>
                    <TableCell>{resource.Arn}</TableCell>
                    <TableCell>{resource.ResourceType}</TableCell>
                    <TableCell>{resource.OwningAccountId}</TableCell>
                    <TableCell>{resource.Region}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            onClick={handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default MultiResourceDialogSelect;
